<template>
    <div class="more1">
        <div class='more'>
            <div class='more_content'>
                <h2>更多相关产品</h2>
                <div class='more_item'>
                    <div v-for='(item,index) in moreList' :key='index' >
                        <img :src='item.url' class='img1' />
                        <h3>{{item.title}}</h3>
                        <p>{{item.text}}</p>
                        <span @click="go(item)">了解更多 →</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'more',
    props: {
        moreList: {
            type: Array,
            default: ''
        },
	},
    data() {
        return {

        }
    },
    mounted() {

    },
    methods:{
        go(item){
            console.log(item, '1111111111')
            if (item.id == 1) {
                window.open('http://www.iboran.com/#/jzy');
            }else if (item.id == 2) {
                window.open('http://www.iboran.com/#/ys');
            }else {
                window.open('http://www.iboran.com/#/jzy');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .more1{
        .more{
            background: url(../assets/more.png) #fff no-repeat center center;
            background-size: auto 688px !important;
            height: 688px;
            .more_content{
                width: 75rem;
                margin: 0 auto;
                animation: r 0.7s ease;
                >h2{
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 26px;
                    letter-spacing: 2px;
                    color: #e31924;
                    padding-top: 90px;
                    text-align: center;
                    padding-bottom: 60px;
                }
                .more_item{
                    display: flex;
                    justify-content: space-between;
                    >div{
                        flex: 0 0 375px;
                        width: 375px;
                        height: 420px;
                        box-shadow: 0px 4px 8px 0px rgba(175, 175, 175, 0.1);
                        border-radius: 6px;
                        transition: all .3s ease-in;
                        >h3{
                            font-size: 20px;
                            font-weight: bold;
                            line-height: 26px;
                            letter-spacing: 1px;
                            color: #333333;
                            padding: 20px 52px;
                        }
                        >.img1{
                            width: 375px;
                        }
                        >p{
                            font-size: 14px;
                            line-height: 26px;
                            height: 104px;
                            letter-spacing: 1px;
                            color: #6c6c6c;
                            padding: 0 52px;
                            display: -webkit-box;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 4;
                        }
                        >span{
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 1px;
                            padding-left: 52px;
                            color: #4C4C4C;
                            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
                            cursor: pointer;
                            margin-top: 18px;
                            display: inline-block;
                        }
                        >span:hover{
                            color: #f53f3f;
                        }
                    }
                    >div:hover{
                        transform: translateY(-8px);
                        box-shadow: 0px 0px 34px 0px rgba(0, 0, 0, 0.14);
                        >h3{
                            color: #f53f3f;
                        }
                    }
                    >div:nth-of-type(1) {
                        background: url(../assets/mbg1.png) #fff no-repeat right bottom;
                    }
                    >div:nth-of-type(2) {
                        background: url(../assets/mbg1.png) #fff no-repeat right bottom;
                    }
                    >div:nth-of-type(3) {
                        background: url(../assets/mbg1.png) #fff no-repeat right bottom;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/More.vue